import request from '@/utils/request'

let IcpApi = {

  /*优惠券列表*/
  queryICP(data, errorback) {
    return request._post('/shop/plus.icp.icp/query', data, errorback);
  },
  /*上传设置模板变量*/
  apiDetail(data, errorback) {
    return request._get('/shop/plus.icp.icp/index', data, errorback);
  },
  /*保存上传设置*/
  editIcpApi(data, errorback) {
    return request._post('/shop/plus.icp.icp/index', data, errorback);
  },

  /*获取icp记录*/
  getRecordList(data, errorback) {
    return request._post('/shop/plus.icp.icp/getRecordList', data, errorback);
  },
}

export default IcpApi;



// WEBPACK FOOTER //
// ./src/api/icp.js